// extracted by mini-css-extract-plugin
module.exports = {"container":"DataViewLoading_container__1yhU0","label":"DataViewLoading_label__ufbvS"};